import { render, staticRenderFns } from "./PostWordsCounter.vue?vue&type=template&id=1dcfcbf5&scoped=true&"
import script from "./PostWordsCounter.vue?vue&type=script&lang=js&"
export * from "./PostWordsCounter.vue?vue&type=script&lang=js&"
import style0 from "./PostWordsCounter.vue?vue&type=style&index=0&id=1dcfcbf5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcfcbf5",
  null
  
)

export default component.exports